module.exports = __webpack_public_path__ + "img/校园.f261241c.png";